import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { Chip } from "@mui/material";
import {
  OrganizationUserDetails,
  OrganizationUserListItem,
} from "services/KnowfullyAdminClient";
import { UserStatusType } from "types/common-types";

export default function StatusChip({
  value,
}: Readonly<{
  value: OrganizationUserListItem | OrganizationUserDetails;
}>) {
  const userStatusTypeName = value.userStatusTypeName?.toLowerCase();
  const color =
    userStatusTypeName === UserStatusType.Active.toLowerCase()
      ? "success"
      : userStatusTypeName === UserStatusType.Inactive.toLowerCase()
      ? "secondary"
      : userStatusTypeName === UserStatusType.Pending.toLowerCase()
      ? "warning"
      : "info";

  return (
    <Chip
      label={userStatusTypeName ?? "unset"}
      size="small"
      variant="outlined"
      icon={<FiberManualRecordIcon />}
      color={color}
    />
  );
}
